import React from 'react';
import { PlayerButton } from './PlayerButton';

interface PlayButtonProps {
  isPlaying: boolean;
  mediaElementId: string;
  onClick: () => void;
}

export const PlayButton = React.memo(function PlayButton({ isPlaying, mediaElementId, onClick }: PlayButtonProps) {
  return (
    <PlayerButton
      className={`kollab-player-play-btn ${isPlaying ? 'kollab-player-play-btn--playing' : ''}`}
      tooltip={isPlaying ? 'Pause' : 'Play'}
      aria-controls={mediaElementId}
      onClick={onClick}
    />
  );
});
